import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Collegamento } from '../models/collegamento';
import { ResourcefulService } from './resourcefulService';



@Injectable({
    providedIn: 'root'
})
export class CollegamentoService extends ResourcefulService<Collegamento>{
    constructor(private httpClient: HttpClient) {
        super(httpClient, Collegamento);
    }
}
